import React from 'react';

import { Button, ScrollView, Divider as UclDivider } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import { Box, BoxProps } from 'components/ui/box';
import { getDesignToken, layout, spacing } from 'styles/constants';

export const Container = ScrollView.withConfig({
  width: 'full',
  marginY: spacing.$13_5,
});

type TotalsRowProps = BoxProps & {
  marginTop?: '$2';
};

export const TotalsRow = ({ marginTop, style, ...props }: TotalsRowProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.totalsRow, marginTop === '$2' && styles.totalsRowMarginTop, style],
  });

export const TotalLabelTitle = withTypography({
  variant: 'copyOne',
  fontSize: 'md',
  bold: true,
  style: { flexGrow: 1, width: '80%' },
});

export const TotalLabel = withTypography({ variant: 'bodyOne', style: { flexGrow: 1 } });

export const Total = withTypography({ variant: 'bodyOne', style: { display: 'flex' } });

export const Divider = UclDivider.withConfig({
  marginY: '$4',
  orientation: 'horizontal',
  thickness: '1',
});

export const DescriptionRow = withTypography({
  variant: 'bodyOne',
  px: '$4',
  pt: '$2',
  accessible: true,
  style: { flexGrow: 1 },
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$4',
  height: '$4',
});

export const StyledLinkButton = Button.withConfig({
  variant: 'ghost',
  justifyContent: 'flex-start',
  _text: {
    variant: 'bodyOne',
    textDecorationLine: 'underline',
    fontSize: 'sm',
    selectable: false,
  },
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: getDesignToken('color-tertiary'),
      },
    },
  },
});

const styles = StyleSheet.create({
  totalsRow: {
    flexDirection: 'row',
    paddingHorizontal: spacing.$4,
    width: layout.full,
  },
  totalsRowMarginTop: {
    marginTop: spacing.$2,
  },
});
